<template>
  <NuxtLink
    :to="to"
    class="-outline-offset-2 absolute cursor-pointer focus-visible:outline-2 focus-visible:outline-primary focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-surface-canvas inset-0 rounded-[inherit] w-full"
    :aria-label="label"
    @click="handleClick"
  />
</template>

<script setup lang="ts">
import type { AnchorHTMLAttributes } from 'vue'
import { NuxtLink } from '#components'
import type { RouteLocationRaw } from 'vue-router'

// Stretched link: renders after the card content, so every sibling control needs a positive z-index to stay hit-testable above it.
const props = defineProps<{
  /** Native click listener forwarded to the link. */
  onClick?: AnchorHTMLAttributes['onClick']
  /** Route the covered card links to. */
  to: RouteLocationRaw
  /** Accessible name, since the link covers the card without carrying text. */
  label?: string | undefined
}>()

const handleClick: NonNullable<AnchorHTMLAttributes['onClick']> = (event) => props.onClick?.(event)
</script>
